import BaseService from '@/ecm/common/BaseService.js';

class NewsLetterService {
  baseUrl = 'newsletter';

    subscribe = (email) => BaseService.post({ url: `${this.baseUrl}/subscribe`, data: { email } });

}
export default new NewsLetterService();